<script setup lang="ts">
import type { GiftSeriesLocation } from '@consumer/types/serializers'
import { faLocationDot } from '@fortawesome/pro-light-svg-icons'
import { ref, computed } from 'vue'
import closeIcon from '@consumer/assets/icons/close.svg?svgicon'
import everywhereIcon from '@consumer/assets/icons/everywhere.svg?svgicon'

withDefaults(defineProps<{
  otherMultiplaceGiftsInSeries: GiftSeriesLocation[]
}>(), {  })

const nonNationwideGiftsInSeries: GiftSeriesLocation[] = __props.otherMultiplaceGiftsInSeries.filter(gift =>
  !gift.nationwideGift,
)

const selectGift = (gift: GiftSeriesLocation) => {
  window.location.href = gift.url
}

const filterText = ref('')
const appliedFilterText = ref('')

const filteredGifts = computed(() => {
  if (!appliedFilterText.value) {
    return nonNationwideGiftsInSeries.slice(0, 5)
  }

  const filtered = nonNationwideGiftsInSeries.filter(gift =>
    gift.featuredCity?.displayName?.toLowerCase().includes(appliedFilterText.value.toLowerCase()),
  )

  return filtered
})

const nationwideGift = computed(() => {
  return __props.otherMultiplaceGiftsInSeries.find(giftSeriesLocation => giftSeriesLocation.nationwideGift)
})

const shouldShowFilter = computed(() => {
  return __props.otherMultiplaceGiftsInSeries.length >= 6
})

function doFilter () {
  appliedFilterText.value = filterText.value
}

</script>
<template>
  <div class="p-[24px] w-[422px] flex flex-col gap-2 city-picker-modal">
    <div class="flex flex-row">
      <div class="text-lg font-weight-600 flex-grow">Pick a city</div>
      <div>
        <GIcon v-close-popper :svg="closeIcon" color="black" size="12px" class="clickable"/>
      </div>
    </div>

    <div v-if="shouldShowFilter" class="flex gap-2 mb-2 items-center">
      <div class="flex-grow">
        <GTextInput
          v-model="filterText"
          type="text"
          placeholder="Enter City Name"
          class="city-picker-input"
          @keyup="doFilter"
        />
      </div>
    </div>

    <V2List v-if="filteredGifts.length > 0 || nationwideGift" class="w-full">
      <V2ListItem
        v-if="nationwideGift"
        :key="nationwideGift.internalSlug"
        class="w-full cursor-pointer city-picker-nationwide"
        label="Nationwide"
        :icon="everywhereIcon"
        @click="selectGift(nationwideGift)"
      />
      <V2ListItem
        v-for="suggestion in filteredGifts"
        :key="suggestion.internalSlug"
        class="w-full cursor-pointer city-picker-city"
        :image="suggestion.featuredCity?.imageThumbUrl"
        :label="suggestion.featuredCity?.displayName"
        :icon="faLocationDot"
        @click="selectGift(suggestion)"
      >
        <template #image="{ image }">
          <CityImage
            :imageUrl="image"
            size="small"
          />
        </template>
      </V2ListItem>
    </V2List>
  </div>
</template>
